import React from "react";
import  ReactDOM  from "react-dom";
import Nav  from "./Nav";
import Intro from "./Intro";
import Skills from "./Skills";
import Project from "./Project";
import Contact from "./Contact";





function App(){
return(
    <div className="full-body" >
    <Nav />
     <Intro  id="intro"/>
     <Skills />
     <Project />
     <Contact id="contact" />
    
    </div>
);


}

export default App;